import { useRef, useState } from "react";

import { Autocomplete, CircularProgress, TextField } from "@mui/material";

import { Bloco } from "../../types/bloco/Bloco";
import useBlocoFetch from "./useBlocoFetch";


type Props = {
    isdisabled?: boolean;
    isLoading?: boolean;
    required?: boolean;
    value?: Bloco | null;
    handleSearchChange: (newValue: Bloco) => void;
};


const TxtBloco = ({
    isdisabled,
    isLoading,

    required,
    value,
    handleSearchChange,

}: Props) => {


    const timeoutRef = useRef<number | null>(null);
    const loading = useRef(false);




    const handleSetLoad = (newValue: boolean) => {
        loading.current = newValue;
    };

    const [inputValue, setInputValue] = useState("");
    const { options } = useBlocoFetch({ inputValue, handleSetLoad });


    return (
        <Autocomplete

            value={value && value.id ? value : null} // 
            size="small"
            options={options}
            isOptionEqualToValue={(option, value) => option.id === value.id}

            getOptionLabel={(option) => {
                const bloco = option as Bloco;
                return bloco.nome ? bloco.nome : "";
            }}
            loading={loading.current}

            onInputChange={(event, newInputValue) => {

                if (timeoutRef.current) {
                    clearTimeout(timeoutRef.current);
                }
                timeoutRef.current = window.setTimeout(() => {
                    setInputValue(newInputValue);


                }, 700); // 300ms delay
            }}

            onChange={(event, newValue) => {
                handleSearchChange(newValue as Bloco);
            }}


            renderInput={(params) => (
                <TextField
                    {...params}
                    label="Bloco de Acompanhamento"
                    required={required ? true : false}
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <>
                                {loading.current ? (
                                    <CircularProgress color="inherit" size={20} />
                                ) : null}
                                {params.InputProps.endAdornment}
                            </>
                        ),
                    }}
                />
            )}

        />
    );








}
export default TxtBloco;

